import React from 'react'
import './notification.css'
import NotificationTable from '../../components/notification/NotificationTable'
const NotificationTableMain = () => {
  return (
    <div>
      <NotificationTable/>
    </div>
  )
}

export default NotificationTableMain
